import React from 'react'
import { useState, useEffect, useRef } from 'react';
import './ComponentsCss/AdminPageEdit.css';
// axios 
import axios from 'axios';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

const AdminPageMsEdit = () => {
  const axiosPrivate = useAxiosPrivate();
  const [AllMSData, SetAllMSData] = useState();
  const [MsSel, SetMsSel] = useState(0);
  // add new ms data 
  const [msId, SetmsId] = useState("");
  const [msDesc, SetmsDesc] = useState("");
  const [msImage, SetmsImage] = useState("");
  const [msLink, SetmsLink] = useState("");
  const [msTitle, SetmsTitle] = useState("");

  const MsMainImageRef = useRef(null);


  const changeMsImageHandler = (event) => {
    //setAxiosNewsMainImage(file);
    SetmsImage(event.target.files[0].name);
  };

  function changeImageFnc(imgSel) {
    if (imgSel == 1) {
      MsMainImageRef.current.click();
    }
  }


  useEffect(() => {
    axiosGetData();
  }, []);

  useEffect(() => {

    console.log("ms sel " + MsSel);
    if (MsSel == -1) {
      SetmsId("");
      SetmsDesc("");
      SetmsImage("");
      SetmsLink("");
      SetmsTitle("");


    } else {
      if (AllMSData != null && AllMSData.length > 0) {
        SetmsId(AllMSData[MsSel]?.id);
        SetmsDesc(AllMSData[MsSel]?.msDesc);
        SetmsImage(AllMSData[MsSel]?.msImage);
        SetmsLink(AllMSData[MsSel]?.msLink);
        SetmsTitle(AllMSData[MsSel]?.msTitle);

      }

    }
  }, [MsSel, AllMSData]);


  const axiosGetData = async () => {
    var finalIP = "";
    // https://stepupkorea.kr/api/msData/getAllMsData
    finalIP = "https://stepupkorea.kr/api/msData/getAllMsData";
    try {
      const response = await axios.get(finalIP

      );
      if (response) {
        console.log(response.data);
        SetAllMSData(response.data);

      } else {

      }

    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Missing Username or Password');
      } else if (err.response?.status === 401) {
        console.log('--Unauthorized');
      } else {
        console.log('ERR');
      }

    }
  }

  const axiosAddMS = async () => {

    try {
      /* 
     const { msDesc, msImage, msLink, msTitle } = req.body;

      */
      var DataJson = "";
      DataJson = JSON.stringify({
        msDesc: msDesc,
        msImage: msImage,
        msLink: msLink,
        msTitle: msTitle

      }, null, 2);


      var finalIP = "";
      // 	"/emergency/rssi/module-status-set/<ip>"
      finalIP = "https://stepupkorea.kr/api/admin/AddMs";
      //console.log(" axiosPostModuleStatus" + finalIP);
      const response = await axiosPrivate.post(finalIP,
        DataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,

        }
      );
      if (response) {
        console.log(" Add ms success !");
        axiosGetData();
      }
    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Username and password are required.');

      } else if (err.response?.status === 401) {
        console.log('-- Wrong conf password ');

      }
      else if (err.response?.status === 402) {
        console.log('-- Username already exists ');

      } else {
        console.log('ERR');
      }

    }
  }
  const axiosUpdateMS = async () => {

    try {
      /* 
        const { msId, msDesc, msImage, msLink, msTitle } = req.body;
      */
      var DataJson = "";
      DataJson = JSON.stringify({
        msId: msId,
        msDesc: msDesc,
        msImage: msImage,
        msLink: msLink,
        msTitle: msTitle,

      }, null, 2);


      var finalIP = "";
      // 	"/emergency/rssi/module-status-set/<ip>"
      finalIP = "https://stepupkorea.kr/api/admin/UpdateMs";
      //console.log(" axiosPostModuleStatus" + finalIP);
      const response = await axiosPrivate.post(finalIP,
        DataJson,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,

        }
      );
      if (response) {
        console.log(" Update ms success !");
        axiosGetData();
      }
    } catch (err) {

      if (!err?.response) {
        console.log('--No Server Response');
      } else if (err.response?.status === 400) {
        console.log('--Username and password are required.');

      } else if (err.response?.status === 401) {
        console.log('-- Wrong conf password ');

      }
      else if (err.response?.status === 402) {
        console.log('-- Username already exists ');

      } else {
        console.log('ERR');
      }

    }
  }
  return (
    <div className='admin-page-edit-main'>
      <div className='admin-page-edit-list'>

        {
          AllMSData != null && AllMSData.length > 0 ?
            AllMSData.map((ms, index) => (
              <div className='admin-page-list-button' onClick={() => SetMsSel(index)}>{ms.id} : {ms.msTitle} </div>


            ))
            : null
        }
        <div className='admin-page-list-button' onClick={() => SetMsSel(-1)} > + 월간 선진 추가 </div>


      </div>
      <div className='admin-page-edit-details'>

        {
          MsSel == -1 ?
            <>


              <br />
              <div className='admin-page-title-text'> 제목: </div>
              <input className='admin-page-input' value={msTitle} onInput={(e) => SetmsTitle(e.target.value)} />


              <div className='admin-page-title-text'> 설명: </div>
              <textarea className='admin-page-input' rows={8} cols={60} value={msDesc} onInput={(e) => SetmsDesc(e.target.value)} />

              <br />

              <div className='admin-page-title-text'> 사진 파일 이름: </div>

              <div className='admin-page-list-button' onClick={() => changeImageFnc(1)}> 파일 선택 </div>
              <input type="file" name="input1" ref={MsMainImageRef} style={{ display: 'none' }}
                onChange={changeMsImageHandler} />
              <input className='admin-page-input' value={msImage} />
              <div className='admin-page-title-text'> 링크 : </div>
              <input className='admin-page-input' value={msLink} onInput={(e) => SetmsLink(e.target.value)} />




              <br />
              <br />
              <div className='admin-page-list-button' onClick={() => axiosAddMS()}>  월간선진 추가 +  </div>

              <br />
              <br />

            </>
            :
            AllMSData != null && AllMSData.length > 0 && MsSel != -1 ?
              <>
                <div className='admin-page-title-text'> ID:  {msId} </div>
                <br />
                <div className='admin-page-title-text'> 제목: </div>
                <input className='admin-page-input' value={msTitle} onInput={(e) => SetmsTitle(e.target.value)} />


                <div className='admin-page-title-text'> 설명: </div>
                <textarea className='admin-page-input' rows={8} cols={60} value={msDesc} onInput={(e) => SetmsDesc(e.target.value)} />

                <br />

                <div className='admin-page-title-text'> 사진 파일 이름: </div>
                <div className='admin-page-list-button' onClick={() => changeImageFnc(1)}> 파일 선택 </div>
                <input type="file" name="input1" ref={MsMainImageRef} style={{ display: 'none' }}
                  onChange={changeMsImageHandler} />
                <input className='admin-page-input' value={msImage} />
                <div className='admin-page-title-text'> 링크 : </div>
                <input className='admin-page-input' value={msLink} onInput={(e) => SetmsLink(e.target.value)} />




                <br />
                <br />
                <div className='admin-page-list-button' onClick={() => axiosUpdateMS()}> 정보 업데이트 </div>

                <br />
                <br />

              </>
              : null
        }

      </div>

    </div>
  )
}
/* 
 
id
msDesc
msImage
msLink
msTitle
*/

export default AdminPageMsEdit